// extracted by mini-css-extract-plugin
export default {"personalHeader":"style_personalHeader__2FYis","date":"style_date__jLsFt","iconBox":"style_iconBox__V51wZ","icon":"style_icon__flxfz"};